import React, { useState, useEffect, useMemo } from 'react';
import styles from './News.module.css';
import headerBg from '../../assets/images/武蔵野大学.jpg';

const FALLBACK_IMAGE = 'https://res.cloudinary.com/de301ufoq/image/upload/v1775915341/%E3%82%B9%E3%82%AF%E3%83%AA%E3%83%BC%E3%83%B3%E3%82%B7%E3%83%A7%E3%83%83%E3%83%88_2026-04-11_22.48.47_xo9nol.png';

function News() {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState('すべて');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || 'https://bohpj-website.onrender.com'}/api/news`)
      .then(res => res.json())
      .then(data => {
        const actualData = Array.isArray(data) ? data : (data.items || []);
        setNewsData(actualData);
      })
      .catch(error => {
        console.error("通信エラー:", error);
        setNewsData([]);
      })
      .finally(() => setLoading(false));
  }, []);

  // dateから年を抽出（"2025.09.08" or "2025-09-08" 両対応）
  const getYear = (date) => date?.split(/[.-]/)?.[0] ?? '';

  // データから年一覧を動的生成（降順）
  const years = useMemo(() => {
    const yearSet = new Set(newsData.map(item => getYear(item.date)).filter(Boolean));
    return Array.from(yearSet).sort((a, b) => b - a);
  }, [newsData]);

  // 選択年でフィルタリング
  const filteredNews = selectedYear === 'すべて'
    ? newsData
    : newsData.filter(item => getYear(item.date) === selectedYear);

  return (
    <div className={styles.container}>
      <header className={styles.homeHeader}>
        <img src={headerBg} alt="武蔵野大学" className={styles.headerImage} />
        <div className={styles.headerOverlay}>
          <h1 className={styles.headerTitle}>News</h1>
        </div>
      </header>

      <div className={styles.newsContentWrapper}>
        <main className={styles.mainContent}>

          <div className={styles.filterSection}>
            <button
              className={`${styles.filterBtn} ${selectedYear === 'すべて' ? styles.active : ''}`}
              onClick={() => setSelectedYear('すべて')}
            >
              すべて
            </button>
            {years.map(year => (
              <button
                key={year}
                className={`${styles.filterBtn} ${selectedYear === year ? styles.active : ''}`}
                onClick={() => setSelectedYear(year)}
              >
                {year}年
              </button>
            ))}
          </div>

          <div className={styles.newsList}>
            {loading
              ? [1, 2, 3, 4, 5].map(i => (
                  <div key={i} className={styles.newsItem}>
                    <div className={`${styles.imageBox} ${styles.skeleton}`} />
                    <div className={styles.textSide}>
                      <p className={styles.skeleton} style={{ width: 100, height: 14, marginBottom: 10 }} />
                      <p className={styles.skeleton} style={{ width: '80%', height: 20, marginBottom: 6 }} />
                      <p className={styles.skeleton} style={{ width: '50%', height: 20 }} />
                    </div>
                  </div>
                ))
              : filteredNews.length === 0
                ? <p className={styles.empty}>{selectedYear}年のニュースはありません。</p>
                : filteredNews.map((item) => (
                    <div key={item.id} className={styles.newsItem}>
                      <div className={styles.imageBox}>
                        <img
                          src={
                            (item.images?.find(img => img.is_thumbnail) || item.images?.[0])?.url
                            || FALLBACK_IMAGE
                          }
                          alt={item.title}
                          className={styles.itemImage}
                        />
                      </div>
                      <div className={styles.textSide}>
                        <p className={styles.dateText}>{item.date}</p>
                        <p className={styles.titleText}>{item.title}</p>
                      </div>
                    </div>
                  ))
            }
          </div>

        </main>
      </div>
    </div>
  );
}

export default News;
